import { FloatButton } from "antd";
import { useTranslation } from "react-i18next";

import {
  EyeOutlined,
  EyeInvisibleOutlined,
  FolderOpenOutlined,
} from "@ant-design/icons";
import RobotGroupCardItem from "features/robot-teleop/components/robot-cards/robot-group-item";
import RobotConnectionCardItem from "features/robot-teleop/components/robot-cards/robot-connection-item";
import { useState } from "react";

const RobotGroupsCard = ({robotGroups, ...props}) => {
  const { t } = useTranslation();

  const shutdownRobotClick = props.shutdownRobotClick;

  const restartRobotClick = props.restartRobotClick;
  const settingRobotClick = props.settingRobotClick;

  const showDeveloperLink = props.ShowDeveloperLink;

  const [showOfflineRobots, setShowOfflineRobots] = useState(
    props?.ShowOfflineRobots
  );

  const [showConnections, setShowConnections] = useState(
    props?.ShowConnections || false
  );

  return (
    <div className="table-responsive">
      {/* <h2>Dashboard</h2> */}

      <FloatButton.Group>
        {showConnections && (
          <FloatButton
            icon={<FolderOpenOutlined />}
            onClick={() => setShowConnections(false)}
            tooltip={<div>{t('dashboard.groupByRobot')}</div>}
            // type="primary"
          />
        )}
        {!showConnections && (
          <FloatButton
            icon={<FolderOpenOutlined />}
            onClick={() => setShowConnections(true)}
            tooltip={<div>{t('dashboard.showAll')}</div>}
            type="primary"
          />
        )}

        {!showOfflineRobots && (
          <FloatButton
            icon={<EyeInvisibleOutlined />}
            onClick={() => setShowOfflineRobots(true)}
            tooltip={<div>{t('dashboard.showOfflineRobots')}</div>}
            type="primary"
          />
        )}

        {showOfflineRobots && (
          <FloatButton
            icon={<EyeOutlined />}
            onClick={() => setShowOfflineRobots(false)}
            tooltip={<div>{t('dashboard.hideOfflineRobots')}</div>}
            // type="primary"
          />
        )}
      </FloatButton.Group>
      <div className="album py-5 bg-light">
        <div className="container">
          <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-md-4 g-4">
            {robotGroups &&
              Object.keys(robotGroups)
                .sort((a, b) => {
                  return robotGroups[a].status < robotGroups[b].status
                    ? 1
                    : robotGroups[a].status == robotGroups[b].status
                    ? 0
                    : -1;
                })
                .map((group_id) => {
                  return (
                    group_id &&
                    (robotGroups[group_id].status === "online" ||
                      showOfflineRobots) && (
                      <RobotGroupCardItem
                        {...props}
                        key={group_id}
                        RobotInfo={robotGroups[group_id]}
                        ShowConnections={showConnections}
                      ></RobotGroupCardItem>
                    )
                  );
                })}
            {showConnections &&
              robotGroups &&
              robotGroups[""] &&
              robotGroups[""].connections
                .sort((a, b) => {
                  return a.status < b.status
                    ? 1
                    : a.status == b.status
                    ? 0
                    : -1;
                })
                .map(
                  (cnn) =>
                    (cnn.status === "online" || showOfflineRobots) && (
                      <RobotConnectionCardItem
                        {...props}
                        key={cnn.id}
                        ConnectionInfo={cnn}
                      ></RobotConnectionCardItem>
                    )
                )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RobotGroupsCard;
